"use strict";

exports.__esModule = true;
exports.getListeners = exports.removeListener = exports.addListener = void 0;
var listeners = {};

var addListener = function addListener(eventName, func) {
  listeners[eventName] = listeners[eventName] || [];
  listeners[eventName].push(func);
};

exports.addListener = addListener;

var removeListener = function removeListener(eventName, func) {
  listeners[eventName] = listeners[eventName] || [];
  var index = listeners[eventName].indexOf(func);

  if (index > -1) {
    listeners[eventName].splice(index, 1);
  }
};

exports.removeListener = removeListener;

var getListeners = function getListeners(eventName) {
  return listeners[eventName] || [];
};

exports.getListeners = getListeners;